// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TaskBillModalContextQueryVariables = Types.Exact<{
  taskId: Types.Scalars['ID']['input'];
}>;


export type TaskBillModalContextQuery = { __typename?: 'Query', task: { __typename?: 'Task', id: string, type: { __typename?: 'TaskTypeDetail', code: Types.TaskType }, project?:
      | { __typename?: 'StandaloneProject', id: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Region', id: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Market', id: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Community', id: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Subdivision', id: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Lot', id: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Structure', id: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Unit', id: string, features: Array<Types.ProjectFeature> }
     | null | undefined, protoBills: Array<{ __typename?: 'ProtoBill', id: string, lineItems: Array<{ __typename?: 'ProtoBillLineItem', amountInCents: number, commitmentLineItem: { __typename?: 'CommitmentLineItem', id: string, owner:
            | { __typename?: 'Commitment', id: string, status: Types.CommitmentStatus, tradePartner?: { __typename?: 'TradePartner', id: string, enableClickToPay: boolean } | null | undefined }
            | { __typename?: 'CommitmentChangeOrder', id: string, status: Types.CommitmentStatus, tradePartner?: { __typename?: 'TradePartner', id: string, enableClickToPay: boolean } | null | undefined }
           } }> }> } };


export const TaskBillModalContextDocument = gql`
    query TaskBillModalContext($taskId: ID!) {
  task(id: $taskId) {
    id
    type {
      code
    }
    project {
      id
      features
    }
    protoBills {
      id
      lineItems {
        amountInCents
        commitmentLineItem {
          id
          owner {
            id
            status
            tradePartner {
              id
              enableClickToPay
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTaskBillModalContextQuery__
 *
 * To run a query within a React component, call `useTaskBillModalContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskBillModalContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskBillModalContextQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useTaskBillModalContextQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskBillModalContextQuery, TaskBillModalContextQueryVariables> & ({ variables: TaskBillModalContextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskBillModalContextQuery, TaskBillModalContextQueryVariables>(TaskBillModalContextDocument, options);
      }
export function useTaskBillModalContextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskBillModalContextQuery, TaskBillModalContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskBillModalContextQuery, TaskBillModalContextQueryVariables>(TaskBillModalContextDocument, options);
        }
// @ts-ignore
export function useTaskBillModalContextSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TaskBillModalContextQuery, TaskBillModalContextQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskBillModalContextQuery, TaskBillModalContextQueryVariables>;
export function useTaskBillModalContextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskBillModalContextQuery, TaskBillModalContextQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskBillModalContextQuery | undefined, TaskBillModalContextQueryVariables>;
export function useTaskBillModalContextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskBillModalContextQuery, TaskBillModalContextQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskBillModalContextQuery, TaskBillModalContextQueryVariables>(TaskBillModalContextDocument, options);
        }
export type TaskBillModalContextQueryHookResult = ReturnType<typeof useTaskBillModalContextQuery>;
export type TaskBillModalContextLazyQueryHookResult = ReturnType<typeof useTaskBillModalContextLazyQuery>;
export type TaskBillModalContextSuspenseQueryHookResult = ReturnType<typeof useTaskBillModalContextSuspenseQuery>;
export type TaskBillModalContextQueryResult = Apollo.QueryResult<TaskBillModalContextQuery, TaskBillModalContextQueryVariables>;